import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDitaPath, selectTocId, setGuideline } from "../../features/counter/counterSlice";
import Version from "../../features/counter/Version";
import CounterApp from "../../features/counter/CounterApp";
import GuidelineNavRouter from "../../features/guideline/GuidelineNavRouter";
import classNames from "classnames";
import useAppModernisation from "../../hooks/useAppModernisation";
import styles from "./GuidelineContent.module.scss";

const generateSelfSearch = (pathname) => {
  const arraySearch = pathname
    .replace("/guidelines/", "")
    .replace("/app/nav/", "")
    .replace("Pregnancy_and_Breastfeeding", "quicklinks")
    .split("/");
  const [glPage, ...rest] = arraySearch;
  return { glPage, submenu: rest };
};

const GuidelineContent = ({ search, pathname }) => {
  const tocId = useSelector(selectTocId);
  const dispatch = useDispatch();
  const refInfo = useRef(null); // Double check
  const guidelineObj = generateSelfSearch(pathname);
  const { isAppMode, isWebModernisationEnabled } = useAppModernisation();

  useEffect(() => {
    dispatch(setGuideline({ search: `&guidelinePage=${guidelineObj.glPage}` }));
    // const searchMap = new URLSearchParams(search);
    // if (searchMap.has("topicfile")) {
    //   setDisplayGuideline(true);
    // }
  }, [search, guidelineObj.glPage]);

  const ditapath = useSelector(selectDitaPath);

  return (
    <div
      className={classNames({
        container: isAppMode,
        [styles.container]: isWebModernisationEnabled,
      })}
    >
      <div className={classNames({ row: isAppMode })}>
        <div className={classNames({ "col-md-12": isAppMode })}>
          <div className="dart-container">
            <div>
              <noscript>You need to enable JavaScript to run this app.</noscript>
              <GuidelineNavRouter guidelineObj={guidelineObj} />
              <div className="columnBlockLayout" id="tocId">
                <div className={"d-none"} id="tocbox">
                  <div id="tocID" dangerouslySetInnerHTML={{ __html: tocId }} />
                  <div id="TOC_ID">
                    {ditapath && (
                      <div id="tg_toc_id">
                        <div
                          className="dartframe fa fa-compress"
                          onClick={() => {
                            document
                              .querySelectorAll("#TOC_ID, #contentId")
                              .forEach((el) => el.classList.toggle("active"));
                          }}
                        ></div>
                        <Version />
                        <CounterApp glPage={guidelineObj.glPage} ref={refInfo} />
                        <span className="username"></span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidelineContent;
